var e = {
	page: {
		title: "Rates & availability",
		subtitle: "Rooms to sell, prices and stay restrictions, night by night",
		bulkEdit: "Bulk edit",
		moreActions: "More actions",
		openCalendar: "Open booking calendar",
		propertyLabel: "Property",
		propertyPlaceholder: "Choose a property",
		searchProperties: "Search properties",
		previousMonth: "Previous month",
		nextMonth: "Next month",
		tooManyRatePlans_one: "Showing the first {{count}} rate plan of this property.",
		tooManyRatePlans_other: "Showing the first {{count}} rate plans of this property."
	},
	calendar: {
		subtitle: {
			hotel: "Bulk edit across rate plans is on the web",
			home: "Bulk edit across listings is on the web"
		},
		pricesIn: "Prices in {{currency}}",
		hint: "Tap a night to edit it. Press and hold a night, then tap another, to edit every night between.",
		rangeStarted: "Now tap the last night of the range",
		editNights_one: "Edit {{count}} night",
		editNights_other: "Edit {{count}} nights",
		roomsMenu: "Open or close rooms…",
		roomsPartial: "Some rooms closed",
		roomsClosed: "All rooms closed",
		weekend: "Weekend"
	},
	legend: {
		external: "Priced by an external engine",
		closed: "Closed",
		locked: "Price locked",
		glyphs: "2+ minimum stay · ≤7 maximum stay · arrow in or out: no arrivals or departures"
	},
	glyphs: {
		closed: "Closed — not for sale",
		minStay_one: "Minimum stay {{count}} night",
		minStay_other: "Minimum stay {{count}} nights",
		maxStay_one: "Maximum stay {{count}} night",
		maxStay_other: "Maximum stay {{count}} nights",
		minShort_one: "{{count}}+",
		minShort_other: "{{count}}+",
		maxShort_one: "≤{{count}}",
		maxShort_other: "≤{{count}}",
		cta: "No arrivals on this day",
		ctd: "No departures on this day"
	},
	grid: {
		booked_one: "{{count}} booked",
		booked_other: "{{count}} booked",
		bookedAndUnsure: "{{booked}} booked +{{unsure}}",
		roomsTooltip: "{{status}} · {{toSell}} to sell · {{booked}} booked · {{pending}} awaiting payment · {{held}} on hold · {{blocked}} blocked",
		externallyPriced: "External price",
		lockedPrice: "An external engine prices this rate plan — its price can't be edited here",
		inertOverride: "Your price for this night, kept but not used while an external engine prices the rate plan",
		noRate: "—",
		inlinePriceLabel: "Price for the night in {{currency}}",
		priceSourceHint: {
			override: "Your price for this night",
			rules: "Set by your pricing rules",
			base: "The base price",
			pricelabs: "From PriceLabs",
			partner: "From your Developer API calendar"
		},
		selectionSummary: "{{plans}} · {{dates}}",
		editSelection: "Edit selection",
		clearSelection: "Clear",
		loadFailed: "The grid could not load"
	},
	editor: {
		title: "Edit rates and restrictions",
		weekdays: "Days of the week",
		weekdaysHint: "The change applies only to these days inside the dates.",
		mode: {
			keep: "Leave as is",
			set: "Set"
		},
		price: "Price per night",
		priceClear: "Back to rules",
		priceLockedTitle: "Price can't change here",
		priceLockedBody: "An external engine prices {{names}}. Restrictions still apply; leave those out to change prices.",
		priceConflict: "An external engine prices {{names}}, so its price can't be changed here. Nothing was saved.",
		availability: "Sale",
		close: "Close",
		open: "Open",
		minStay: "Minimum stay",
		maxStay: "Maximum stay",
		stayClear: "Remove",
		nightsUnit: "nights",
		closedToArrival: "Arrivals",
		noArrivals: "No arrivals",
		allowArrivals: "Allow arrivals",
		closedToDeparture: "Departures",
		noDepartures: "No departures",
		allowDepartures: "Allow departures",
		nothingToChangeHint: "Choose at least one thing to change.",
		save: "Save changes"
	},
	bulk: {
		title: "Bulk edit rates & availability",
		from: "First night",
		to: "Last night",
		submit: "Apply changes",
		sections: {
			dates: "Dates",
			roomStatus: "Room status",
			prices: "Prices",
			restrictions: "Restrictions"
		},
		roomStatus: {
			label: "Rooms",
			open: "Open rooms",
			close: "Close rooms",
			scope: "Applies to every room of {{roomTypes}}. Rooms already booked or on hold stay sold.",
			reason: "Why the rooms close"
		}
	},
	empty: {
		noRatePlans: {
			title: "No {{listings}} to price yet",
			body: "Prices and restrictions are set per rate plan. Add one to start filling in the grid.",
			openProperty: "Open property"
		},
		noProperties: {
			title: "No properties yet",
			body: "Add a property, and its rates and availability show up here night by night.",
			action: "Add property"
		},
		noPrices: {
			title: "No prices for this month yet",
			body: "Prices appear here once they reach the grid. Try another month, or check back shortly."
		}
	},
	toast: {
		saved: "Rates updated",
		saveFailed: "Changes weren't saved",
		saveFailedBody: "Something went wrong. Nothing changed — try again.",
		priceLocked: "Price can't change here",
		bulkSaved: "Changes applied",
		bulkRatePlans_one: "{{count}} rate plan updated",
		bulkRatePlans_other: "{{count}} rate plans updated",
		bulkClosed_one: "{{count}} room type closed",
		bulkClosed_other: "{{count}} room types closed",
		bulkOpened_one: "{{count}} room type opened",
		bulkOpened_other: "{{count}} room types opened",
		bulkSkipped_one: "{{count}} night was already sold and stayed open",
		bulkSkipped_other: "{{count}} nights were already sold and stayed open",
		roomStatusFailed: "Room status wasn't fully applied",
		roomStatusPartial_one: "{{count}} room type changed before the error. Try again for the rest.",
		roomStatusPartial_other: "{{count}} room types changed before the error. Try again for the rest.",
		roomStatusPartialRatesSaved_one: "Rates were saved. {{count}} room type changed before the error. Try again for the rest.",
		roomStatusPartialRatesSaved_other: "Rates were saved. {{count}} room types changed before the error. Try again for the rest."
	},
	validation: {
		fromRequired: "Choose the first night",
		toRequired: "Choose the last night",
		fromPast: "Past nights can't change",
		toBeforeFrom: "The last night is before the first",
		spanTooLong: "At most {{max}} nights at a time",
		weekdaysRequired: "Choose at least one day",
		priceInvalid: "Enter a price of 0 or more",
		stayInvalid: "Enter a whole number of nights, 1 or more",
		maxBelowMin: "The maximum stay is shorter than the minimum",
		ratePlansRequired: "Choose at least one",
		tooManyRatePlans: "At most {{max}} at a time",
		tooManyBlockDates: "Open or close at most {{max}} nights at a time"
	}
};
//#endregion
export { e as default };
